module.exports = __webpack_public_path__ + "static/img/female-bg-id.17bf7dd5.png";